import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";

//add university
export const addUniversity = (model) => {
  let url = "";
  if (model.id == null) {
    url = `${CONFIG.BASE_URL}/university/add.json`;
  } else {
    url = `${CONFIG.BASE_URL}/university/universityedit`;
  }

  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//list university
export const getUniversityList = (model) => {
  const url = `${CONFIG.BASE_URL}/university/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//add institute
export const addInstitute = (model) => {
  console.log(model);
  let url = "";
  if (model.id == null) {
    url = `${CONFIG.BASE_URL}/institute/add.json`;
  } else {
    url = `${CONFIG.BASE_URL}/institute/instituteedit`;
  }

  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//list institute
export const getInstituteList = (model) => {
  const url = `${CONFIG.BASE_URL}/institution/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//list Enquiry
export const getEnquiryList = (model) => {
  const url = `${CONFIG.BASE_URL}/enquiry/get-enquiry`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//map university
export const createMapUniversityList = (model) => {
  const url = `${CONFIG.BASE_URL}/university/map.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//map university
export const getMapUniversityList = (model) => {
  const url = `${CONFIG.BASE_URL}/university-institute/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//map university recruiter
export const createMapRecruiterUniversityList = (model) => {
  const url = `${CONFIG.BASE_URL}/recruiter-university/map.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//map university recruiter
export const getMapRecruiterUniversityList = (model) => {
  const url = `${CONFIG.BASE_URL}/recruiter-university/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//add employer
export const addEmployer = (model) => {
  let url = "";
  if (model.id == null) {
    url = `${CONFIG.BASE_URL}/employer/add.json`;
  } else {
    url = `${CONFIG.BASE_URL}/employer/employeredit`;
  }

  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//list employer
export const getEmployerList = (model) => {
  const url = `${CONFIG.BASE_URL}/employer/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//add recruiter
export const addRecruiter = (model) => {
  let url = "";
  if (model.id == null) {
    url = `${CONFIG.BASE_URL}/recruiter/add.json`;
  } else {
    url = `${CONFIG.BASE_URL}/recruiter/recruiteredit`;
  }
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//list recruiter
export const getRecruiterList = (model) => {
  const url = `${CONFIG.BASE_URL}/recruiter/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

//list company
export const getCompanyList = (model) => {
  const url = `${CONFIG.BASE_URL}/company/list.json`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

// Total Enquiry
export const getTotalEnquiry = (model) => {
  const url = `${CONFIG.BASE_URL}/enquiry/total-enquiry`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const changeStatus = (model) => {
  const url = `${CONFIG.BASE_URL}/user/changestatus`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};

export const universityRegister = (model) => {
  const url = `${CONFIG.BASE_URL}/university/register.json`;
  return axios.post(url, model).then((res) => {
    if (res.data) {
      localStorage.setItem("status", res.data.status);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("username", res.data.username);
      localStorage.setItem("roleid", res.data.roleid);
      localStorage.setItem("email", res.data.email);
      localStorage.setItem("message", res.data.message);
      localStorage.setItem("profilepic", res.data.profilepic);
      localStorage.setItem("userrole", res.data.userrole);
    }
    return res.data
  })

};




